/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_Over_AmountInputs */

const cs_deal_splits_over_amount = /** @type {(inputs: Deal_Splits_Over_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Součet částek překračuje provizi kanceláře.`)
};

const en_deal_splits_over_amount = /** @type {(inputs: Deal_Splits_Over_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split amounts exceed agency commission.`)
};

/**
* | output |
* | --- |
* | "Split amounts exceed agency commission." |
*
* @param {Deal_Splits_Over_AmountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_over_amount = /** @type {((inputs?: Deal_Splits_Over_AmountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_Over_AmountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_over_amount(inputs)
	return cs_deal_splits_over_amount(inputs)
});